import { ProfileOutlineAvatar } from '@/libs/material/icons';
import { DS_HEIGHT } from '@calm/evexia-design-tokens';
import { Box } from '@rhg/libs/material';
import { styleIconContainer } from '@rhg/libs/material/sx';

const styleIconWrapper = {
    ...styleIconContainer,
    '& > svg': {
        height: DS_HEIGHT.AVATAR_SMALL,
        width: DS_HEIGHT.AVATAR_SMALL,
    },
    backgroundColor: 'background.paper',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

export const AgeGenderFormIcon = () => (
    <Box sx={styleIconWrapper}>
        <ProfileOutlineAvatar inheritViewBox={false} viewBox="-1 -1 24 24" />
    </Box>
);
